import { gql } from "@apollo/client";

const GET_FACTSHEET_PDF_BY_ERASMUS_CODE = gql`
    query factsheetPdfByErasmusCode($erasmusCode: String!) {
        factsheetPdfByErasmusCode(erasmusCode: $erasmusCode)
    }
`;

export default GET_FACTSHEET_PDF_BY_ERASMUS_CODE;